export default {
      id: "action-icon-declined-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-icon-declined",
      toString: function () {
        return this.url;
      }
    }